(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder-one-time"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bundle-builder-one-time')) {
    customElements.define(
      'bundle-builder-one-time',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';
          this.flavors = [...this.querySelectorAll('[data-flavor]')];
          this.priceNow = this.querySelector('[data-price-now]');
          this.prices = this.querySelector('[data-prices]');
          this.cta = this.querySelector('[data-cta]');
          this.ctaPrice = this.querySelector('[data-cta-price]');
          this.live = this.querySelector('[data-live]');
          this.onClick = this.onClick.bind(this);
          this.onDisabledClick = this.onDisabledClick.bind(this);
          this.addEventListener('click', this.onDisabledClick, true);
          this.addEventListener('click', this.onClick);
          this.render(false);
        }

        onDisabledClick(event) {
          const disabledCard = event.target.closest('.bundle-builder__group.is-disabled, .bundle-builder__flavor.is-disabled');
          if (!disabledCard || !this.contains(disabledCard)) return;
          event.preventDefault();
          event.stopPropagation();
        }

        isFlavorDisabled(flavor) {
          if (!flavor) return true;
          return flavor.dataset.disabled === 'true'
            || flavor.classList.contains('is-disabled')
            || Boolean(flavor.closest('.bundle-builder__group.is-disabled'));
        }

        onClick(event) {
          const qtyButton = event.target.closest('[data-qty-action]');
          if (qtyButton && this.contains(qtyButton)) {
            event.preventDefault();
            if (this.isFlavorDisabled(qtyButton.closest('[data-flavor]'))) return;
            this.changeQty(qtyButton);
            return;
          }
          const addBtn = event.target.closest('.js-bundle-add-to-cart');
          if (addBtn && this.contains(addBtn)) {
            event.preventDefault();
            this.addToCart(addBtn);
          }
        }

        changeQty(button) {
          const flavor = button.closest('[data-flavor]');
          if (!flavor || this.isFlavorDisabled(flavor)) return;
          const current = Number(flavor.dataset.qty) || 0;
          const next = button.dataset.qtyAction === 'plus' ? Math.min(99, current + 1) : Math.max(0, current - 1);
          flavor.dataset.qty = String(next);
          const value = flavor.querySelector('[data-qty-value]');
          if (value) value.textContent = String(next);
          const qtyInput = flavor.querySelector('.js-bundle-qty-input');
          if (qtyInput) qtyInput.value = String(next);
          const minus = flavor.querySelector('[data-qty-action="minus"]');
          if (minus) minus.disabled = next === 0;
          this.render(true);
        }

        render(animate) {
          let qty = 0;
          const unitPrice = Number(this.dataset.baseUnit) || 59;
          this.querySelectorAll('.bundle-card:not(.is-disabled)').forEach((card) => {
            const qtyInput = card.querySelector('.js-bundle-qty-input');
            const count = qtyInput ? parseInt(qtyInput.value, 10) : 0;
            if (count > 0) qty += count;
          });

          const saleCents = Math.round(qty * unitPrice * 100);
          const saleLabel = this.formatCents(saleCents);
          if (this.priceNow) this.priceNow.textContent = saleLabel;
          if (this.ctaPrice) this.ctaPrice.textContent = saleLabel;
          if (this.cta) {
            const empty = qty === 0;
            this.cta.classList.toggle('is-empty', empty);
            this.cta.disabled = empty;
            if (empty) this.cta.setAttribute('aria-disabled', 'true');
            else this.cta.removeAttribute('aria-disabled');
          }
          if (animate && this.prices) {
            this.prices.classList.remove('is-updating');
            void this.prices.offsetWidth;
            this.prices.classList.add('is-updating');
          }
          if (this.live) {
            this.live.textContent = qty > 0
              ? `${qty} packs, ${saleLabel}`
              : this.dataset.emptyMessage || '';
          }
        }

        addToCart(button) {
          if (!button || button.disabled || button.classList.contains('is-loading') || button.getAttribute('aria-disabled') === 'true') return;
          this.setCartError('');

          const items = [];
          let missingVariant = false;
          this.querySelectorAll('.bundle-card:not(.is-disabled)').forEach((card) => {
            const qtyInput = card.querySelector('.js-bundle-qty-input');
            const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 0;
            const variantId = card.dataset.variantId;
            if (!(quantity > 0)) return;
            if (!variantId) {
              missingVariant = true;
              return;
            }
            items.push({
              id: parseInt(variantId, 10),
              quantity: quantity
            });
          });

          if (missingVariant || items.length === 0) {
            this.setCartError(missingVariant
              ? 'Choose a product variant for each pack before adding to cart.'
              : '');
            return;
          }

          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          })
            .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
            .then(({ ok, data }) => {
              if (!ok) {
                const message = (data && (data.description || data.message)) || 'Could not add the bundle to cart.';
                throw new Error(message);
              }
              return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
            })
            .then((cart) => {
              const tier = window.FortifiedBundleTier;
              if (!tier || typeof tier.sync !== 'function') return cart;
              return tier.sync(cart, { refresh: false }).then((updated) => updated || cart);
            })
            .then((cart) => {
              this.announceCart(cart, items);
              if (this.live) this.live.textContent = 'Added to cart';
            })
            .catch((err) => {
              this.setCartError(err.message || 'Could not add the bundle to cart.');
              console.error('Cart add error:', err);
            })
            .finally(() => {
              button.classList.remove('is-loading');
              button.removeAttribute('aria-busy');
            });
        }

        announceCart(cart, items) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          let resolve;
          const promise = new Promise((res) => { resolve = res; });
          promise.catch(() => {});
          const currency = cart.currency || 'USD';
          const money = (cents) => ((cents || 0) / 100).toFixed(2);
          const payload = {
            action: 'add',
            context: 'product',
            lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
            promise
          };
          const summary = {
            id: cart.token || '',
            totalQuantity: cart.item_count || 0,
            cost: { totalAmount: { amount: money(cart.total_price), currencyCode: currency } },
            lines: (cart.items || []).map((line) => ({
              id: line.key,
              quantity: line.quantity,
              cost: { totalAmount: { amount: money(line.final_line_price), currencyCode: currency } }
            })),
            discountCodes: (cart.discount_codes || []).map((entry) => {
              const code = typeof entry === 'string' ? entry : (entry && entry.code) || '';
              return code ? { code, applicable: !entry || entry.applicable !== false } : null;
            }).filter(Boolean)
          };
          const dispatch = (Ctor) => {
            let evt = null;
            try { evt = Ctor ? new Ctor(payload) : null; } catch (error) { evt = null; }
            if (!evt) {
              evt = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
              Object.keys(payload).forEach((key) => { evt[key] = payload[key]; });
            }
            document.dispatchEvent(evt);
            resolve({
              cart: summary,
              detail: {
                items: cart.items || [],
                itemCount: cart.item_count || 0,
                source: 'bundle-builder-one-time',
                didError: false
              }
            });
            const host = document.querySelector('cart-drawer-component');
            const drawer = host && host.closest ? host.closest('theme-drawer') : null;
            if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) {
              try { drawer.open(); } catch (error) { /* drawer stays closed */ }
            }
          };
          import('@shopify/events')
            .then((mod) => dispatch(mod && mod.CartLinesUpdateEvent))
            .catch(() => dispatch(null));
        }

        setCartError(message) {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.hidden = !message;
          error.textContent = message || '';
        }

        formatCents(cents) {
          const amount = (cents / 100).toFixed(2);
          const open = '{'.repeat(2);
          const close = '}'.repeat(2);
          const format = this.dataset.moneyFormat || '$' + open + 'amount' + close;
          const withComma = amount.replace('.', ',');
          const token = (name) => new RegExp(open + '\\s*' + name + '\\s*' + close, 'g');
          return format
            .replace(token('amount_no_decimals_with_comma_separator'), String(Math.round(cents / 100)))
            .replace(token('amount_with_comma_separator'), withComma)
            .replace(token('amount_no_decimals'), String(Math.round(cents / 100)))
            .replace(token('amount'), amount);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fortified-header-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fortified-header')) {
    class FortifiedHeader extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ftdBound === 'true') return;
        this.dataset.ftdBound = 'true';
        this.toggleBtn = this.querySelector('[data-ftd-menu-toggle]');
        this.drawer = this.querySelector('[data-ftd-drawer]');
        this.panel = this.querySelector('[data-ftd-panel]');
        this.shopToggle = this.querySelector('.js-shop-toggle');
        this.shopContent = this.querySelector('.js-shop-content');
        this.backdrop = this.querySelector('[data-ftd-backdrop]');
        this.countEl = this.querySelector('[data-ftd-cart-count]');
        this.liveEl = this.querySelector('[data-ftd-cart-live]');
        this.cartBtn = this.querySelector('[aria-controls="cart-drawer"]');
        this.previouslyFocused = null;

        this.onToggle = () => {
          if (this.classList.contains('is-open')) this.close();
          else this.open();
        };
        this.onKeydown = (event) => this.handleKeydown(event);
        this.onCart = (event) => this.handleCart(event);
        this.onCartDrawer = (event) => {
          if (event.target?.id !== 'cart-drawer' || !this.cartBtn) return;
          this.cartBtn.setAttribute('aria-expanded', event.type === 'theme-drawer:open' ? 'true' : 'false');
        };
        this.onPageShow = () => this.syncStoredCount();
        this.onResize = () => {
          if (window.matchMedia('(min-width: 990px)').matches) this.close();
          else if (this.classList.contains('is-open')) this.syncOffset();
        };

        this.toggleBtn?.addEventListener('click', this.onToggle);
        this.backdrop?.addEventListener('click', () => this.close());
        this.panel?.addEventListener('click', (event) => {
          if (event.target.closest('.js-shop-toggle')) return;
          if (event.target.closest('[data-ftd-close]')) {
            this.close();
            return;
          }
          const link = event.target.closest('a[href]');
          if (!link || !this.panel.contains(link)) return;
          const href = link.getAttribute('href') || '';
          if (href === '' || href === '#' || href.charAt(0) === '#') this.close();
        });
        this.shopToggle?.addEventListener('click', (event) => {
          event.preventDefault();
          const expanded = this.shopToggle.getAttribute('aria-expanded') === 'true';
          this.setShopOpen(!expanded);
        });
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:cart:lines-update', this.onCart);
        document.addEventListener('theme-drawer:open', this.onCartDrawer);
        document.addEventListener('theme-drawer:close', this.onCartDrawer);
        window.addEventListener('pageshow', this.onPageShow);
        window.addEventListener('resize', this.onResize);

        this.querySelectorAll('[data-ftd-accordion]').forEach((button) => {
          button.addEventListener('click', () => {
            const group = button.closest('[data-ftd-group]');
            const sub = group?.querySelector('.ftd-drawer__sub');
            const open = !group.classList.contains('is-open');
            group.classList.toggle('is-open', open);
            button.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (sub) sub.hidden = !open;
          });
        });

        this.querySelectorAll('[data-ftd-drop]').forEach((item) => {
          const link = item.querySelector('[data-ftd-drop-link]');
          const setOpen = (open) => link?.setAttribute('aria-expanded', open ? 'true' : 'false');
          item.addEventListener('mouseenter', () => setOpen(true));
          item.addEventListener('mouseleave', () => setOpen(false));
          item.addEventListener('focusin', () => setOpen(true));
          item.addEventListener('focusout', (event) => {
            if (!item.contains(event.relatedTarget)) setOpen(false);
          });
        });

        this.syncStoredCount();
      }

      disconnectedCallback() {
        this.dataset.ftdBound = 'false';
        this.toggleBtn?.removeEventListener('click', this.onToggle);
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:cart:lines-update', this.onCart);
        document.removeEventListener('theme-drawer:open', this.onCartDrawer);
        document.removeEventListener('theme-drawer:close', this.onCartDrawer);
        window.removeEventListener('pageshow', this.onPageShow);
        window.removeEventListener('resize', this.onResize);
        document.documentElement.classList.remove('ftd-header-lock');
        document.body.classList.remove('overflow-hidden');
      }

      open() {
        if (!this.drawer || window.matchMedia('(min-width: 990px)').matches) return;
        this.previouslyFocused = document.activeElement;
        this.syncOffset();
        this.classList.add('is-open');
        this.drawer.classList.add('is-open');
        this.drawer.removeAttribute('inert');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.querySelectorAll('[data-ftd-inert]').forEach((node) => node.setAttribute('inert', ''));
        this.toggleBtn?.setAttribute('aria-expanded', 'true');
        if (this.toggleBtn?.dataset.labelClose) this.toggleBtn.setAttribute('aria-label', this.toggleBtn.dataset.labelClose);
        document.documentElement.classList.add('ftd-header-lock');
        document.body.classList.toggle('overflow-hidden', true);
        this.setShopOpen(false);
        const target = this.panel?.querySelector('[data-ftd-close]') || this.panel?.querySelector('button, a') || this.toggleBtn;
        target?.focus();
      }

      close() {
        if (!this.drawer || !this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.drawer.classList.remove('is-open');
        this.drawer.classList.add('is-closing');
        this.querySelectorAll('[data-ftd-inert]').forEach((node) => node.removeAttribute('inert'));
        this.drawer.setAttribute('inert', '');
        this.drawer.setAttribute('aria-hidden', 'true');
        this.toggleBtn?.setAttribute('aria-expanded', 'false');
        if (this.toggleBtn?.dataset.labelOpen) this.toggleBtn.setAttribute('aria-label', this.toggleBtn.dataset.labelOpen);
        document.documentElement.classList.remove('ftd-header-lock');
        document.body.classList.toggle('overflow-hidden', false);
        this.setShopOpen(false);
        window.setTimeout(() => this.drawer?.classList.remove('is-closing'), 300);
        if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') this.previouslyFocused.focus({ preventScroll: true });
        else this.toggleBtn?.focus({ preventScroll: true });
      }

      syncOffset() {
        if (this.drawer) this.drawer.style.top = '0px';
      }

      setShopOpen(open) {
        if (!this.shopToggle) return;
        this.shopToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!this.shopContent) return;
        if (open) this.shopContent.removeAttribute('inert');
        else this.shopContent.setAttribute('inert', '');
      }

      focusable() {
        const nodes = [];
        this.panel?.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])').forEach((node) => {
          if (node.closest('[hidden], [inert]')) return;
          if (node.getClientRects().length) nodes.push(node);
        });
        return nodes;
      }

      handleKeydown(event) {
        if (!this.classList.contains('is-open')) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          if (this.shopToggle?.getAttribute('aria-expanded') === 'true') {
            this.setShopOpen(false);
            this.shopToggle.focus();
          } else {
            this.close();
          }
          return;
        }
        if (event.key !== 'Tab') return;
        const items = this.focusable();
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      handleCart(event) {
        const apply = (result) => {
          const cart = result?.cart || {};
          const count = cart.totalQuantity ?? cart.item_count ?? result?.detail?.itemCount;
          if (count === undefined || count === null) return;
          this.setCount(count);
        };
        if (event.promise && typeof event.promise.then === 'function') {
          event.promise.then(apply).catch(() => {});
          return;
        }
        apply(event);
      }

      setCount(count) {
        const value = Math.max(0, Number(count) || 0);
        const label = value > 99 ? '99+' : String(value);
        if (this.countEl) {
          this.countEl.textContent = value === 0 ? '' : label;
          this.countEl.classList.toggle('ftd-header__count--empty', value === 0);
        }
        if (this.liveEl) {
          const prefix = this.liveEl.dataset.label || '';
          this.liveEl.textContent = prefix ? `${prefix}: ${value}` : String(value);
        }
      }

      syncStoredCount() {
        try {
          const raw = sessionStorage.getItem('cart-count');
          if (!raw) return;
          const parsed = JSON.parse(raw);
          if (!parsed || Date.now() - parsed.timestamp > 10000) return;
          const count = parseInt(parsed.value, 10);
          if (count >= 0) this.setCount(count);
        } catch (_) {}
      }
    }

    customElements.define('fortified-header', FortifiedHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-accordion-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-accordion-faq')) {
    customElements.define(
      'pdp-accordion-faq',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';
          this.allowMultiple = this.dataset.allowMultiple === 'true';
          this.classList.add('is-ready');

          this.onClick = (event) => {
            const summary = event.target.closest('summary');
            if (!summary || !this.contains(summary)) return;
            const details = summary.parentElement;
            if (!details || details.tagName !== 'DETAILS') return;
            event.preventDefault();

            if (details.classList.contains('is-open')) {
              this.closeItem(details);
              return;
            }

            if (!this.allowMultiple) {
              this.querySelectorAll('details.is-open').forEach((openItem) => {
                if (openItem !== details) this.closeItem(openItem);
              });
            }

            this.openItem(details);
          };

          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          if (this.onClick) this.removeEventListener('click', this.onClick);
          this.dataset.bound = 'false';
        }

        bumpToken(details) {
          const next = (Number(details.dataset.closeToken) || 0) + 1;
          details.dataset.closeToken = String(next);
          return String(next);
        }

        openItem(details) {
          this.bumpToken(details);
          details.open = true;
          const panel = details.querySelector('.pdp-accordion__panel');
          if (panel) panel.getBoundingClientRect();
          details.classList.add('is-open');
        }

        closeItem(details) {
          const token = this.bumpToken(details);
          const panel = details.querySelector('.pdp-accordion__panel');
          details.classList.remove('is-open');

          const finish = () => {
            if (details.dataset.closeToken !== token) return;
            if (details.classList.contains('is-open')) return;
            details.open = false;
          };

          if (panel) {
            const onEnd = (event) => {
              if (event.target !== panel || event.propertyName !== 'grid-template-rows') return;
              panel.removeEventListener('transitionend', onEnd);
              finish();
            };
            panel.addEventListener('transitionend', onEnd);
          }

          window.setTimeout(finish, 450);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-bundle-builder')) {
    customElements.define(
      'pdp-bundle-builder',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';
          this.flavors = [...this.querySelectorAll('[data-flavor]')];
          this.plans = [...this.querySelectorAll('[data-plan]')];
          this.steps = [...this.querySelectorAll('[data-pack]')];
          this.nodes = [...this.querySelectorAll('[data-node]')];
          this.badge = this.querySelector('[data-badge]');
          this.priceWas = this.querySelector('[data-price-was]');
          this.priceNow = this.querySelector('[data-price-now]');
          this.prices = this.querySelector('[data-prices]');
          this.cta = this.querySelector('[data-cta]');
          this.ctaPrice = this.querySelector('[data-cta-price]');
          this.live = this.querySelector('[data-live]');
          this.messageLead = this.querySelector('[data-message-lead]');
          this.messageRate = this.querySelector('[data-message-rate]');
          this.messageHint = this.querySelector('[data-message-hint]');
          this.fill = this.querySelector('[data-fill]');
          this.onClick = this.onClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onDisabledClick = this.onDisabledClick.bind(this);
          this.addEventListener('click', this.onDisabledClick, true);
          this.addEventListener('click', this.onClick);
          const group = this.querySelector('[role="radiogroup"]');
          if (group) group.addEventListener('keydown', this.onKeydown);
          this.syncSellingPlan();
          this.render(false);
        }

        onDisabledClick(event) {
          const disabledCard = event.target.closest('.bundle-builder__group.is-disabled, .bundle-builder__flavor.is-disabled');
          if (!disabledCard || !this.contains(disabledCard)) return;
          event.preventDefault();
          event.stopPropagation();
        }

        isFlavorDisabled(flavor) {
          if (!flavor) return true;
          return flavor.dataset.disabled === 'true'
            || flavor.classList.contains('is-disabled')
            || Boolean(flavor.closest('.bundle-builder__group.is-disabled'));
        }

        onClick(event) {
          const qtyButton = event.target.closest('[data-qty-action]');
          if (qtyButton && this.contains(qtyButton)) {
            event.preventDefault();
            if (this.isFlavorDisabled(qtyButton.closest('[data-flavor]'))) return;
            this.changeQty(qtyButton);
            return;
          }
          const plan = event.target.closest('[data-plan]');
          if (plan && this.contains(plan)) {
            event.preventDefault();
            this.selectPlan(plan);
            return;
          }
          const addBtn = event.target.closest('.js-bundle-add-to-cart');
          if (addBtn && this.contains(addBtn)) {
            event.preventDefault();
            this.addToCart(addBtn);
          }
        }

        onKeydown(event) {
          if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(event.key)) return;
          event.preventDefault();
          const current = this.plans.findIndex((plan) => plan.getAttribute('aria-checked') === 'true');
          const delta = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
          const next = this.plans[(current + delta + this.plans.length) % this.plans.length];
          this.selectPlan(next);
          next.focus();
        }

        changeQty(button) {
          const flavor = button.closest('[data-flavor]');
          if (!flavor || this.isFlavorDisabled(flavor)) return;
          const current = Number(flavor.dataset.qty) || 0;
          const next = button.dataset.qtyAction === 'plus' ? Math.min(99, current + 1) : Math.max(0, current - 1);
          flavor.dataset.qty = String(next);
          const value = flavor.querySelector('[data-qty-value]');
          if (value) value.textContent = String(next);
          const minus = flavor.querySelector('[data-qty-action="minus"]');
          if (minus) minus.disabled = next === 0;
          this.render(true);
        }

        selectPlan(plan) {
          this.plans.forEach((item) => {
            const active = item === plan;
            item.classList.toggle('is-active', active);
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-checked', active ? 'true' : 'false');
            item.tabIndex = active ? 0 : -1;
          });
          this.querySelectorAll('[data-perk]').forEach((perk) => {
            perk.hidden = perk.dataset.planId !== plan.dataset.planId;
          });
          this.syncSellingPlan(plan);
        }

        syncSellingPlan(plan) {
          const selected = plan || this.selectedPlan();
          const planInput = this.querySelector('input[name="selling_plan"]');
          if (!planInput) return;
          planInput.value = selected && selected.dataset.sellingPlanId ? selected.dataset.sellingPlanId : '';
        }

        selectedPlan() {
          return this.plans.find((plan) => plan.getAttribute('aria-checked') === 'true') || this.plans[0];
        }

        packState(qty) {
          let current = null;
          let next = null;
          this.steps.forEach((step) => {
            const min = Number(step.dataset.min) || 0;
            if (qty >= min && (!current || min >= Number(current.dataset.min))) current = step;
            if (qty < min && (!next || min < Number(next.dataset.min))) next = step;
          });
          return { current, next };
        }

        render(animate) {
          let qty = 0;
          let compare = 0;
          const fallbackUnit = Number(this.dataset.baseUnit) || 0;
          this.flavors.forEach((flavor) => {
            if (this.isFlavorDisabled(flavor)) return;
            const count = Number(flavor.dataset.qty) || 0;
            const unit = Number(flavor.dataset.unit) || fallbackUnit;
            qty += count;
            compare += unit * count;
          });

          const { current, next } = this.packState(qty);
          const applied = current && qty > 0 ? Number(current.dataset.rate) || 0 : 0;
          const compareCents = Math.round(compare * 100);
          const saleCents = Math.round((compareCents * (100 - applied)) / 100);
          const reachedMin = current && qty > 0 ? Number(current.dataset.min) : -1;

          this.steps.forEach((step) => {
            const on = qty > 0 && qty >= Number(step.dataset.min);
            step.classList.toggle('is-active', on);
          });
          this.nodes.forEach((node) => {
            const done = qty > 0 && qty >= Number(node.dataset.min);
            node.classList.toggle('is-done', done);
            node.classList.toggle('is-locked', !done);
          });

          let fill = 0;
          if (qty > 0 && this.steps.length > 1 && reachedMin >= 0) {
            const index = this.steps.findIndex((step) => Number(step.dataset.min) === reachedMin);
            const safeIndex = index < 0 ? 0 : index;
            fill = safeIndex / (this.steps.length - 1);
          }
          this.style.setProperty('--bundle-fill', String(fill));

          if (this.messageLead && this.messageRate && this.messageHint) {
            if (qty > 0) {
              this.messageLead.textContent = `${this.dataset.saveLabel || 'You save'} `;
              this.messageRate.textContent = `${applied}%`;
              const hint = (next && next.dataset.hint) || (current && (current.dataset.hint || current.dataset.reward)) || '';
              this.messageHint.textContent = hint ? ` · ${hint}` : '';
            } else {
              this.messageLead.textContent = this.dataset.emptyMessage || '';
              this.messageRate.textContent = '';
              this.messageHint.textContent = '';
            }
          }

          const badgeText = qty > 0 ? ((current && current.dataset.pill) || '') : '';
          if (this.badge) {
            this.badge.hidden = !badgeText;
            this.badge.textContent = badgeText;
          }

          const saleLabel = this.formatCents(saleCents);
          const compareLabel = this.formatCents(compareCents);
          if (this.priceNow) this.priceNow.textContent = saleLabel;
          if (this.ctaPrice) this.ctaPrice.textContent = saleLabel;
          if (this.priceWas) {
            this.priceWas.textContent = compareLabel;
            this.priceWas.hidden = !(qty > 0 && compareCents > saleCents);
          }
          if (this.cta) {
            const empty = qty === 0;
            this.cta.classList.toggle('is-empty', empty);
            if (empty) this.cta.setAttribute('aria-disabled', 'true');
            else this.cta.removeAttribute('aria-disabled');
          }
          if (animate && this.prices) {
            this.prices.classList.remove('is-updating');
            void this.prices.offsetWidth;
            this.prices.classList.add('is-updating');
          }
          if (this.live) {
            this.live.textContent = qty > 0
              ? `${qty} packs, ${saleLabel}`
              : this.dataset.emptyMessage || '';
          }
        }

        addToCart(button) {
          if (!button || button.classList.contains('is-loading') || button.getAttribute('aria-disabled') === 'true') return;
          this.setCartError('');

          const subToggle = this.querySelector('.js-purchase-type-sub') || document.querySelector('.js-purchase-type-sub');
          const isSubscription = !subToggle || subToggle.checked;
          const activePlanBtn = this.querySelector('.js-frequency-btn.is-active');
          const planHost = this.querySelector('.bundle-frequency-selector');
          const selectedSellingPlan = (activePlanBtn && activePlanBtn.dataset.sellingPlanId)
            || (planHost && planHost.dataset.defaultPlan)
            || '3136848028';

          const items = [];
          let missingVariant = false;
          this.flavors.forEach((card) => {
            if (this.isFlavorDisabled(card)) return;
            const quantity = Number(card.dataset.qty) || 0;
            const variantId = card.dataset.variantId;
            if (quantity <= 0) return;
            if (!variantId) {
              missingVariant = true;
              return;
            }
            const item = { id: Number(variantId), quantity };
            if (isSubscription && selectedSellingPlan) item.selling_plan = Number(selectedSellingPlan);
            items.push(item);
          });

          if (missingVariant || items.length === 0) {
            this.setCartError(missingVariant
              ? 'Choose a product variant for each pack before adding to cart.'
              : '');
            return;
          }

          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          })
            .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
            .then(({ ok, data }) => {
              if (!ok) {
                const message = (data && (data.description || data.message)) || 'Could not add the bundle to cart.';
                throw new Error(message);
              }
              return this.notifyLoop();
            })
            .then(() => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json()))
            .then((cart) => {
              const tier = window.FortifiedBundleTier;
              if (!tier || typeof tier.sync !== 'function') return cart;
              return tier.sync(cart, { refresh: false }).then((updated) => updated || cart);
            })
            .then((cart) => {
              window.Loop = window.Loop || {};
              if (cart && Array.isArray(cart.items)) window.Loop.bundleCartAllItems = cart.items;
              document.dispatchEvent(new CustomEvent('loop:cart:updated', { bubbles: true }));
              this.announceCart(cart, items);
              if (this.live) this.live.textContent = 'Added to cart';
            })
            .catch((err) => {
              this.setCartError(err.message || 'Could not add the bundle to cart.');
              console.error('Cart add error:', err);
            })
            .finally(() => {
              button.classList.remove('is-loading');
              button.removeAttribute('aria-busy');
            });
        }

        notifyLoop() {
          window.Loop = window.Loop || {};
          if (typeof window.Loop.refreshCart !== 'function') return Promise.resolve();
          try {
            const result = window.Loop.refreshCart();
            if (result && typeof result.then === 'function') {
              return result.catch((error) => {
                console.error('Loop refreshCart error:', error);
              });
            }
          } catch (error) {
            console.error('Loop refreshCart error:', error);
          }
          return Promise.resolve();
        }

        announceCart(cart, items) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          let resolve;
          const promise = new Promise((res) => { resolve = res; });
          promise.catch(() => {});
          const currency = cart.currency || 'USD';
          const money = (cents) => ((cents || 0) / 100).toFixed(2);
          const payload = {
            action: 'add',
            context: 'product',
            lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
            promise
          };
          const summary = {
            id: cart.token || '',
            totalQuantity: cart.item_count || 0,
            cost: { totalAmount: { amount: money(cart.total_price), currencyCode: currency } },
            lines: (cart.items || []).map((line) => ({
              id: line.key,
              quantity: line.quantity,
              cost: { totalAmount: { amount: money(line.final_line_price), currencyCode: currency } }
            })),
            discountCodes: (cart.discount_codes || []).map((entry) => {
              const code = typeof entry === 'string' ? entry : (entry && entry.code) || '';
              return code ? { code, applicable: !entry || entry.applicable !== false } : null;
            }).filter(Boolean)
          };
          const dispatch = (Ctor) => {
            let evt = null;
            try { evt = Ctor ? new Ctor(payload) : null; } catch (error) { evt = null; }
            if (!evt) {
              evt = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
              Object.keys(payload).forEach((key) => { evt[key] = payload[key]; });
            }
            document.dispatchEvent(evt);
            resolve({
              cart: summary,
              detail: {
                items: cart.items || [],
                itemCount: cart.item_count || 0,
                source: 'pdp-bundle-builder',
                didError: false
              }
            });
            const host = document.querySelector('cart-drawer-component');
            const drawer = host && host.closest ? host.closest('theme-drawer') : null;
            if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) {
              try { drawer.open(); } catch (error) { /* drawer stays closed */ }
            }
          };
          import('@shopify/events')
            .then((mod) => dispatch(mod && mod.CartLinesUpdateEvent))
            .catch(() => dispatch(null));
        }

        setCartError(message) {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.hidden = !message;
          error.textContent = message || '';
        }

        formatCents(cents) {
          const amount = (cents / 100).toFixed(2);
          const open = '{'.repeat(2);
          const close = '}'.repeat(2);
          const format = this.dataset.moneyFormat || '$' + open + 'amount' + close;
          const withComma = amount.replace('.', ',');
          const token = (name) => new RegExp(open + '\\s*' + name + '\\s*' + close, 'g');
          return format
            .replace(token('amount_no_decimals_with_comma_separator'), String(Math.round(cents / 100)))
            .replace(token('amount_with_comma_separator'), withComma)
            .replace(token('amount_no_decimals'), String(Math.round(cents / 100)))
            .replace(token('amount'), amount);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-comparison')) {
    customElements.define(
      'pdp-comparison',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';

          this.track = this.querySelector('[data-comparison-track]');
          this.bar = this.querySelector('[data-comparison-bar]');
          this.thumb = this.querySelector('[data-comparison-thumb]');
          if (!this.track || !this.bar || !this.thumb) return;

          this.onScroll = () => this.updateThumb();
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          this.observer = new ResizeObserver(() => this.updateThumb());
          this.observer.observe(this.track);

          this.onPointerDown = (event) => this.startDrag(event);
          this.thumb.addEventListener('pointerdown', this.onPointerDown);

          this.updateThumb();
        }

        updateThumb() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const overflows = max > 1;

          this.bar.hidden = !overflows;
          this.track.tabIndex = overflows ? 0 : -1;

          if (!overflows) return;

          const thumbWidth = Math.min(88, this.bar.clientWidth);
          const travel = Math.max(this.bar.clientWidth - thumbWidth, 0);
          const progress = this.track.scrollLeft / max;

          this.thumb.style.width = thumbWidth + 'px';
          this.thumb.style.transform = 'translateX(' + travel * progress + 'px)';
        }

        startDrag(event) {
          if (event.button !== 0) return;
          event.preventDefault();
          this.thumb.setPointerCapture(event.pointerId);

          const startX = event.clientX;
          const startScroll = this.track.scrollLeft;
          const max = this.track.scrollWidth - this.track.clientWidth;
          const travel = Math.max(this.bar.clientWidth - this.thumb.clientWidth, 1);

          const move = (ev) => {
            const dx = ev.clientX - startX;
            this.track.scrollLeft = startScroll + (dx / travel) * max;
          };

          const up = () => {
            this.thumb.removeEventListener('pointermove', move);
            this.thumb.removeEventListener('pointerup', up);
            this.thumb.removeEventListener('pointercancel', up);
          };

          this.thumb.addEventListener('pointermove', move);
          this.thumb.addEventListener('pointerup', up);
          this.thumb.addEventListener('pointercancel', up);
        }

        disconnectedCallback() {
          if (this.track && this.onScroll) {
            this.track.removeEventListener('scroll', this.onScroll);
          }
          if (this.thumb && this.onPointerDown) {
            this.thumb.removeEventListener('pointerdown', this.onPointerDown);
          }
          if (this.observer) this.observer.disconnect();
          this.dataset.bound = 'false';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-creatine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-main')) {
    customElements.define(
      'pdp-main',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';

          const hero = this.querySelector('[data-pdp-hero] img');
          const thumbs = this.querySelectorAll('[data-pdp-thumb]');

          thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => {
              if (!hero || !thumb.dataset.full) return;
              hero.src = thumb.dataset.full;
              hero.srcset = thumb.dataset.srcset || '';
              hero.alt = thumb.dataset.alt || '';
              thumbs.forEach((item) => {
                const active = item === thumb;
                item.classList.toggle('is-active', active);
                item.setAttribute('aria-pressed', active ? 'true' : 'false');
              });
            });
          });

          const form = this.querySelector('.js-pdp-creatine-form');
          if (form) syncCreatineSellingPlan(form);
        }
      }
    );
  }

  function syncCreatineSellingPlan(form) {
    const planInput = form.querySelector('.js-creatine-selling-plan');
    if (!planInput) return;
    const isSubscription = Boolean(form.querySelector('.js-purchase-type[value="subscription"]')?.checked);
    if (isSubscription) {
      planInput.disabled = false;
      planInput.value = form.getAttribute('data-selling-plan') || '3136848028';
    } else {
      planInput.value = '';
      planInput.disabled = true;
    }
  }

  function creatineCartError(form, message) {
    const error = form.querySelector('[data-creatine-cart-error]');
    if (!error) return;
    error.hidden = !message;
    error.textContent = message || '';
  }

  function announceCreatineCart(cart, itemPayload) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    let resolve;
    const promise = new Promise((res) => {
      resolve = res;
    });
    promise.catch(() => {});
    const currency = cart.currency || 'USD';
    const money = (cents) => ((cents || 0) / 100).toFixed(2);
    const payload = {
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(itemPayload.id), quantity: itemPayload.quantity }],
      promise
    };
    const summary = {
      id: cart.token || '',
      totalQuantity: cart.item_count || 0,
      cost: { totalAmount: { amount: money(cart.total_price), currencyCode: currency } },
      lines: (cart.items || []).map((line) => ({
        id: line.key,
        quantity: line.quantity,
        cost: { totalAmount: { amount: money(line.final_line_price), currencyCode: currency } }
      })),
      discountCodes: []
    };
    const dispatch = (Ctor) => {
      let evt = null;
      try {
        evt = Ctor ? new Ctor(payload) : null;
      } catch (error) {
        evt = null;
      }
      if (!evt) {
        evt = new Event('shopify:cart:lines-update', { bubbles: true, composed: true });
        Object.keys(payload).forEach((key) => {
          evt[key] = payload[key];
        });
      }
      document.dispatchEvent(evt);
      resolve({
        cart: summary,
        detail: {
          items: cart.items || [],
          itemCount: cart.item_count || 0,
          source: 'pdp-creatine',
          didError: false
        }
      });
    };
    import('@shopify/events')
      .then((mod) => dispatch(mod && mod.CartLinesUpdateEvent))
      .catch(() => dispatch(null));
  }

  if (!window.__pdpCreatineCartBound) {
    window.__pdpCreatineCartBound = true;

    document.addEventListener('change', function (e) {
      const radio = e.target.closest('.js-pdp-creatine-form .js-purchase-type');
      if (!radio) return;
      const form = radio.closest('.js-pdp-creatine-form');
      if (form) syncCreatineSellingPlan(form);
    });

    document.addEventListener('submit', function (e) {
      const form = e.target.closest('.js-pdp-creatine-form');
      if (!form) return;

      e.preventDefault();

      const variantId = form.querySelector('[name="id"]')?.value;
      const isSubscription = form.querySelector('.js-purchase-type[value="subscription"]')?.checked;
      const onceSelected = form.querySelector('.js-purchase-type[value="onetime"]')?.checked;
      let submitBtn = e.submitter;
      if (!submitBtn || !form.contains(submitBtn)) {
        submitBtn = form.querySelector(onceSelected ? '.pdp-main__cta--once' : '.pdp-main__cta--flavors');
      }

      syncCreatineSellingPlan(form);
      if (!variantId) return;

      const itemPayload = {
        id: parseInt(variantId, 10),
        quantity: 1
      };

      if (isSubscription) {
        itemPayload.selling_plan = parseInt(form.getAttribute('data-selling-plan'), 10) || 3136848028;
      }

      creatineCartError(form, '');
      if (submitBtn) {
        submitBtn.classList.add('is-loading');
        submitBtn.setAttribute('aria-busy', 'true');
      }

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [itemPayload] })
      })
        .then((res) => res.json().then((data) => {
          if (!res.ok) {
            const message = (data && (data.description || data.message)) || 'Could not add creatine to cart.';
            throw new Error(message);
          }
          return data;
        }))
        .then(() => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json()))
        .then((cart) => {
          announceCreatineCart(cart, itemPayload);
        })
        .catch((err) => {
          creatineCartError(form, err.message || 'Could not add creatine to cart.');
          console.error('Creatine cart add error:', err);
        })
        .finally(() => {
          if (submitBtn) {
            submitBtn.classList.remove('is-loading');
            submitBtn.removeAttribute('aria-busy');
          }
        });
    });
  }

  document.querySelectorAll('.js-pdp-creatine-form').forEach((form) => syncCreatineSellingPlan(form));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-image-trio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-image-trio')) {
    customElements.define(
      'pdp-image-trio',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';

          this.track = this.querySelector('[data-trio-track]');
          this.bar = this.querySelector('[data-trio-bar]');
          this.thumb = this.querySelector('[data-trio-thumb]');
          if (!this.track || !this.bar || !this.thumb) return;

          this.onScroll = () => this.updateThumb();
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          this.observer = new ResizeObserver(() => this.updateThumb());
          this.observer.observe(this.track);

          this.onPointerDown = (event) => this.startDrag(event);
          this.thumb.addEventListener('pointerdown', this.onPointerDown);

          this.updateThumb();
        }

        updateThumb() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const overflows = max > 1;

          this.bar.hidden = !overflows;
          this.track.tabIndex = overflows ? 0 : -1;

          if (!overflows) return;

          const ratio = this.track.clientWidth / this.track.scrollWidth;
          const thumbWidth = Math.max(this.bar.clientWidth * ratio, 40);
          const travel = Math.max(this.bar.clientWidth - thumbWidth, 0);
          const progress = this.track.scrollLeft / max;

          this.thumb.style.width = thumbWidth + 'px';
          this.thumb.style.transform = 'translateX(' + travel * progress + 'px)';
        }

        startDrag(event) {
          if (event.button !== 0) return;
          event.preventDefault();
          this.thumb.setPointerCapture(event.pointerId);

          const startX = event.clientX;
          const startScroll = this.track.scrollLeft;
          const max = this.track.scrollWidth - this.track.clientWidth;
          const travel = Math.max(this.bar.clientWidth - this.thumb.clientWidth, 1);

          const move = (ev) => {
            const dx = ev.clientX - startX;
            this.track.scrollLeft = startScroll + (dx / travel) * max;
          };

          const up = () => {
            this.thumb.removeEventListener('pointermove', move);
            this.thumb.removeEventListener('pointerup', up);
            this.thumb.removeEventListener('pointercancel', up);
          };

          this.thumb.addEventListener('pointermove', move);
          this.thumb.addEventListener('pointerup', up);
          this.thumb.addEventListener('pointercancel', up);
        }

        disconnectedCallback() {
          if (this.track && this.onScroll) {
            this.track.removeEventListener('scroll', this.onScroll);
          }
          if (this.thumb && this.onPointerDown) {
            this.thumb.removeEventListener('pointerdown', this.onPointerDown);
          }
          if (this.observer) this.observer.disconnect();
          this.dataset.bound = 'false';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-ingredients')) {
    customElements.define(
      'pdp-ingredients',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';

          this.addEventListener('click', (event) => {
            const card = event.target.closest('[data-ingredient-card]');
            if (!card || !this.contains(card)) return;

            const willOpen = !card.classList.contains('is-active');
            this.querySelectorAll('[data-ingredient-card].is-active').forEach((openCard) => {
              if (openCard !== card) this.setOpen(openCard, false);
            });
            this.setOpen(card, willOpen);
          });
        }

        setOpen(card, open) {
          card.classList.toggle('is-open', open);
          card.classList.toggle('is-active', open);
          const toggle = card.querySelector('[data-ingredient-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-main')) {
    customElements.define(
      'pdp-main',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';

          const hero = this.querySelector('[data-pdp-hero] img');
          const thumbs = this.querySelectorAll('[data-pdp-thumb]');

          thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => {
              if (!hero || !thumb.dataset.full) return;
              hero.src = thumb.dataset.full;
              hero.srcset = thumb.dataset.srcset || '';
              hero.alt = thumb.dataset.alt || '';
              thumbs.forEach((item) => {
                const active = item === thumb;
                item.classList.toggle('is-active', active);
                item.setAttribute('aria-pressed', active ? 'true' : 'false');
              });
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-video-showcase')) {
    customElements.define(
      'pdp-video-showcase',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === 'true') return;
          this.dataset.bound = 'true';

          this.dragged = false;
          this.pointerX = 0;

          this.onPointerDown = (event) => {
            this.dragged = false;
            this.pointerX = event.clientX;
          };

          this.onPointerMove = (event) => {
            if (Math.abs(event.clientX - this.pointerX) > 10) this.dragged = true;
          };

          this.onClick = (event) => {
            if (this.dragged) {
              this.dragged = false;
              return;
            }

            const card = event.target.closest('.pdp-video-card');
            if (!card || !this.contains(card) || card.dataset.playable !== 'true') return;
            this.toggle(card);
          };

          this.addEventListener('pointerdown', this.onPointerDown);
          this.addEventListener('pointermove', this.onPointerMove);
          this.addEventListener('click', this.onClick);

          this.querySelectorAll('video').forEach((video) => {
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.addEventListener('pause', () => {
              const card = video.closest('.pdp-video-card');
              if (!card || !card.classList.contains('is-playing')) return;
              card.classList.remove('is-playing');
              this.setPressed(card, false);
            });
            video.addEventListener('ended', () => {
              const card = video.closest('.pdp-video-card');
              if (!card) return;
              card.classList.remove('is-playing', 'is-loading');
              this.setPressed(card, false);
            });
          });
        }

        disconnectedCallback() {
          this.removeEventListener('pointerdown', this.onPointerDown);
          this.removeEventListener('pointermove', this.onPointerMove);
          this.removeEventListener('click', this.onClick);
          this.dataset.bound = 'false';
        }

        toggle(card) {
          if (card.classList.contains('is-playing') || card.classList.contains('is-loading')) {
            this.pause(card);
            return;
          }
          this.play(card);
        }

        play(card) {
          this.querySelectorAll('.pdp-video-card.is-playing, .pdp-video-card.is-loading').forEach((other) => {
            if (other !== card) this.pause(other);
          });

          const video = card.querySelector('video');
          const embed = card.querySelector('[data-embed]');

          if (video) {
            const poster = card.querySelector('.pdp-video-card__poster');
            if (poster) {
              const src = poster.currentSrc || poster.getAttribute('src');
              if (src) video.poster = src;
            }
            video.playsInline = true;
            video.loop = true;
            video.controls = false;
            video.muted = false;
            card.classList.add('is-loading');
            const pending = video.play();
            if (pending && typeof pending.then === 'function') {
              pending
                .then(() => {
                  card.classList.remove('is-loading');
                  card.classList.add('is-playing');
                  this.setPressed(card, true);
                })
                .catch(() => {
                  video.muted = true;
                  video
                    .play()
                    .then(() => {
                      card.classList.remove('is-loading');
                      card.classList.add('is-playing');
                      this.setPressed(card, true);
                    })
                    .catch(() => {
                      card.classList.remove('is-loading');
                      this.setPressed(card, false);
                    });
                });
            }
            return;
          }

          if (!embed) return;
          const url = this.embedUrl(embed.dataset.provider, embed.dataset.videoId);
          if (!url) return;

          embed.replaceChildren();
          const iframe = document.createElement('iframe');
          iframe.className = 'pdp-video-card__iframe';
          iframe.src = url;
          iframe.title = card.dataset.title || 'Video';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.addEventListener('load', () => {
            if (!embed.contains(iframe) || !card.classList.contains('is-loading')) return;
            card.classList.remove('is-loading');
            card.classList.add('is-playing');
            this.setPressed(card, true);
          });
          embed.hidden = false;
          embed.appendChild(iframe);
          card.classList.add('is-loading');
          this.setPressed(card, true);
        }

        pause(card) {
          card.classList.remove('is-playing', 'is-loading');
          const video = card.querySelector('video');
          if (video && !video.paused) video.pause();
          const embed = card.querySelector('[data-embed]');
          if (embed) {
            embed.hidden = true;
            embed.replaceChildren();
          }
          this.setPressed(card, false);
        }

        setPressed(card, playing) {
          const button = card.querySelector('.pdp-video-card__toggle');
          if (!button) return;
          button.setAttribute('aria-pressed', playing ? 'true' : 'false');
          const label = playing ? button.dataset.labelPause : button.dataset.labelPlay;
          if (label) button.setAttribute('aria-label', label);
        }

        embedUrl(provider, id) {
          if (!id) return '';
          const encoded = encodeURIComponent(id);
          if (provider === 'youtube') {
            return (
              'https://www.youtube.com/embed/' +
              encoded +
              '?autoplay=1&playsinline=1&rel=0&loop=1&playlist=' +
              encoded
            );
          }
          if (provider === 'vimeo') {
            return (
              'https://player.vimeo.com/video/' +
              encoded +
              '?autoplay=1&playsinline=1&loop=1&title=0&byline=0&portrait=0'
            );
          }
          return '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
